import React from "react";
import "./Instructor.css";
import partha from "../images/partha.jpeg";
import mihtu from "../images/Mithu-Sebait.jpeg";

const InstructorDetails = [
  {
    id: 1,
    name: "Mithu Sebait",
    designation: "Founder",
    photo: mihtu,
    fb: "https://www.facebook.com/profile.php?id=100075042755899&mibextid=ZbWKwL",
    insta: "",
  },
  {
    id: 2,
    name: "Partha Sebait",
    designation: "Instructor",
    photo: partha,
    fb: "https://www.facebook.com/sopnodi?mibextid=ZbWKwL",
    insta: "https://instagram.com/partha.sebait?igshid=MzRlODBiNWFlZA==",
  },
];

const Instructor = () => {
  return (
    <div className="instructors">
      <div className="instructor">
        <span>Instructors Details</span>

        <div className="card">
          {InstructorDetails.map((a) => {
            return (
              <div className="intro-details">
                <div className="instructor-img">
                  <img src={a.photo} alt="Instructor img" />
                </div>
                <div className="details">
                  <p>{a.name}</p>
                  <div className="instructor-links">
                    <div>
                      <a href={a.fb} target="_blank">
                        <i class="fa-brands fa-facebook"></i>
                      </a>
                      <a href={a.insta} target="_blank">
                        <i class="fa-brands fa-instagram"></i>
                      </a>
                    </div>
                    <p>{a.designation}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Instructor;
